document.addEventListener("DOMContentLoaded", function () {
  // Toggle the hamburger menu
  // document.querySelector(".hamburger").addEventListener("click", function() {
  //     this.classList.toggle("is-active");
  //     document.querySelector('.dashboard-menu').classList.toggle("menu-active");
  //     document.body.classList.toggle("body-menu-active");
  // });

  // Toggle the parent navigation
  document.querySelectorAll(".parent-nav").forEach(function (navItem) {
    navItem.addEventListener("click", function () {
      this.classList.toggle("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll("input, textarea");

  inputs.forEach((input) => {
    input.addEventListener("focus", () => {
      try {
        input.previousElementSibling.classList.add("focused");
      } catch (e) {}
    });

    input.addEventListener("blur", () => {
      if (input.value === "") {
        try {
          input.previousElementSibling.classList.remove("focused");
        } catch (e) {}
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Tab functionality
  const tabs = document.querySelectorAll(".community-tab");
  const contents = document.querySelectorAll(".community-tab-content");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.getAttribute("data-target");
      contents.forEach((content) => {
        content.classList.remove("active");
        if (content.id === target) {
          content.classList.add("active");
        }
      });
    });
  });

  // Drag and Drop functionality between boxes
  const items = document.querySelectorAll(".community-box-item");
  const boxes = document.querySelectorAll(".community-box");

  items.forEach((item) => {
    item.addEventListener("dragstart", (e) => {
      e.dataTransfer.setData("text/plain", item.id);
    });
  });

  boxes.forEach((box) => {
    box.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    box.addEventListener("drop", (e) => {
      e.preventDefault();
      const id = e.dataTransfer.getData("text/plain");
      const draggable = document.getElementById(id);
      box.appendChild(draggable);
    });
  });
});

// Student dashboard tabs section java script code
document.addEventListener("DOMContentLoaded", function () {
  const studentTabs = document.querySelectorAll(".student-tab");
  const studentContents = document.querySelectorAll(".st-content");

  studentTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      studentTabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.getAttribute("data-target");
      studentContents.forEach((content) => {
        content.classList.remove("active");
        if (content.id === target) {
          content.classList.add("active");
        }
      });
    });
  });
});

// Student dashbord field group add or remove

document.addEventListener("DOMContentLoaded", function () {
  var container = document.getElementById("field-group-container");

  // Function to create a new field group
  function createFieldGroup() {
    var newGroup = document.createElement("div");
    newGroup.classList.add("field-group");

    var select = document.createElement("select");
    select.classList.add("security-type");
    select.innerHTML = `
            <option>Select Security Type</option>
            <option>Select Security 1</option>
            <option>Select Security 2</option>
            <option>Select Security 3</option>
            <option>Select Security 4</option>
        `;

    var inputAmount = document.createElement("input");
    inputAmount.type = "text";
    inputAmount.name = "amount[]";
    inputAmount.placeholder = "Amount";
    inputAmount.classList.add("amount-field");

    var inputMaturity = document.createElement("input");
    inputMaturity.type = "text";
    inputMaturity.name = "field[]";
    inputMaturity.placeholder = "Maturity (Quarters)";
    inputMaturity.classList.add("maturity-field");

    var buttonContainer = document.createElement("div");
    buttonContainer.classList.add("add-remove-buttons");

    var addButton = document.createElement("button");
    addButton.type = "button";
    addButton.classList.add("add-field");
    addButton.textContent = "+";

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.classList.add("remove-field");
    removeButton.textContent = "-";

    buttonContainer.appendChild(addButton);
    buttonContainer.appendChild(removeButton);

    newGroup.appendChild(select);
    newGroup.appendChild(inputAmount);
    newGroup.appendChild(inputMaturity);
    newGroup.appendChild(buttonContainer);

    return newGroup;
  }

  // Add a new field group when the "+" button is clicked
  if (container) {
    container.addEventListener("click", function (event) {
      if (event.target.classList.contains("add-field")) {
        var newGroup = createFieldGroup();
        container.appendChild(newGroup);
      }
    });

    // Remove a field group when the "-" button is clicked
    container.addEventListener("click", function (event) {
      if (event.target.classList.contains("remove-field")) {
        var group = event.target.closest(".field-group");
        if (group && container.children.length > 1) {
          group.remove();
        }
      }
    });
  }
});

//Security Tabs Code

document.addEventListener("DOMContentLoaded", function () {
  const securityTabs = document.querySelectorAll(".security-tab");
  const securityContents = document.querySelectorAll(".security-content");

  securityTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      securityTabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.getAttribute("data-target");
      securityContents.forEach((content) => {
        content.classList.remove("active");
        if (content.id === target) {
          content.classList.add("active");
        }
      });
    });
  });
});

// Popup Codes

document.addEventListener("DOMContentLoaded", function () {
  // Delete Modal
  var deleteModal = document.getElementById("delete-modal");
  var deleteBtns = document.querySelectorAll(".delete-btn");
  var deleteClose = document.querySelectorAll(".delete-close");
  var yesButton = document.querySelector(".yes-button");
  var bodyElem = document.querySelector("body");

  deleteBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      deleteModal.style.display = "block";
      bodyElem.classList.add("popup-open");
    });
  });

  deleteClose.forEach(function (btnClose) {
    btnClose.addEventListener("click", function () {
      deleteModal.style.display = "none";
      bodyElem.classList.remove("popup-open");
    });
  });

  yesButton.onclick = function () {
    deleteModal.style.display = "none";
    bodyElem.classList.remove("popup-open");
  };

  window.onclick = function (event) {
    if (event.target == deleteModal) {
      deleteModal.style.display = "none";
      bodyElem.classList.remove("popup-open");
    }
  };

  // Reset Modal
  var resetModal = document.getElementById("reset-modal");
  var resetBtns = document.querySelectorAll(".reset-btn");
  var resetClose = document.querySelectorAll(".reset-close");

  var bodyElem = document.querySelector("body");

  resetBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      resetModal.style.display = "block";
      bodyElem.classList.add("popup-open");
    });
  });

  resetClose.forEach(function (btnClose) {
    btnClose.addEventListener("click", function () {
      resetModal.style.display = "none";
      bodyElem.classList.remove("popup-open");
    });
  });

  window.onclick = function (event) {
    if (event.target == resetModal) {
      resetModal.style.display = "none";
      bodyElem.classList.remove("popup-open");
    }
  };

  // Forward Modal
  var forwardModal = document.getElementById("forward-modal");
  var forwardBtns = document.querySelectorAll(".forward-btn");
  var forwardButton = document.querySelectorAll(".forward-close");
  var bodyElem = document.querySelector("body");

  forwardBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      forwardModal.style.display = "block";
      bodyElem.classList.add("popup-open");
    });
  });

  forwardButton.forEach(function (btnClose) {
    btnClose.addEventListener("click", function () {
      forwardModal.style.display = "none";
      bodyElem.classList.remove("popup-open");
    });
  });

  window.onclick = function (event) {
    if (event.target == forwardModal) {
      forwardModal.style.display = "none";
      bodyElem.classList.remove("popup-open");
    }
  };

  // Add Simulation Modal Code

  var addSimulationModal = document.getElementById("add-simulation-modal");
  var addSimulationBtn = document.getElementById("add-simulation-btn");
  var simulationButton = document.querySelectorAll(".add-simulation-close");
  var bodyElem = document.querySelector("body");
  try {
    addSimulationBtn.onclick = function () {
      addSimulationModal.style.display = "block";
      bodyElem.classList.add("popup-open");
    };

    simulationButton.forEach(function (btnClose) {
      btnClose.addEventListener("click", function () {
        addSimulationModal.style.display = "none";
        bodyElem.classList.remove("popup-open");
      });
    });

    window.onclick = function (event) {
      if (event.target == addSimulationModal) {
        addSimulationModal.style.display = "none";
        bodyElem.classList.remove("popup-open");
      }
    };
  } catch (e) {}
});

document.addEventListener("DOMContentLoaded", function () {
  var acc = document.querySelectorAll(".aba-accordion");
  acc.forEach(function (button) {
    button.addEventListener("click", function () {
      // Close all other panels
      acc.forEach(function (otherButton) {
        if (otherButton !== button) {
          otherButton.classList.remove("active");
          var otherPanel = otherButton.nextElementSibling;
          otherPanel.style.maxHeight = null;
          otherPanel.classList.remove("show");
        }
      });

      // Toggle the clicked panel
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.classList.remove("show");
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.classList.add("show");
      }
    });
  });
});
